import { Box, Flex, Text, LegacyText } from "flicket-ui";

interface ProductCardProps {
  imgSrc: string;
  title: string;
  inStock?: boolean;
  price: string;
  badge?: string;
}

export const ProductCard = (props: ProductCardProps) => {
  return (
    <Flex
      flexDir="column"
      borderRadius={"12px" as any}
      overflow="hidden"
      boxShadow="container"
      position="relative"
    >
      {props.badge && (
        <Box
          backgroundColor="P300"
          position="absolute"
          top={0}
          left={0}
          m={2}
          p="1/2"
          lineHeight="normal"
          borderRadius="xs"
        >
          <LegacyText
            letterSpacing={"-0.17px" as any}
            fontSize={1}
            textTransform="uppercase"
            color="white"
            fontWeight="demiBold"
          >
            {props.badge}
          </LegacyText>
        </Box>
      )}
      <Box
        height={240}
        width="100%"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundImage={`url(${props.imgSrc})`}
      />
      <Flex flex={1} flexDir="column" backgroundColor="white" p={2}>
        <LegacyText
          textTransform="uppercase"
          variant="heavy.M"
          color="N800"
          letterSpacing={"-0.165px" as any}
        >
          {props.title}
        </LegacyText>
        <LegacyText
          fontWeight="demiBold"
          color="N600"
          fontSize={2}
          letterSpacing={"-0.165px" as any}
        >
          {props.inStock ? "In Stock" : "Out of Stock"}
        </LegacyText>
        <Box flex={1} />
        <LegacyText
          mt={1}
          color="N800"
          fontSize={3}
          letterSpacing={"-0.165px" as any}
        >
          {props.price}
        </LegacyText>
      </Flex>
    </Flex>
  );
};
